import type { BadgeTone } from '@/components/ui/badge';

/**
 * The one colour map of tool states, used by every screen (traceability, tool view, ML,
 * analytics, labelling): new = success, worn = warning, broken = error, anything else neutral.
 */
export function toolStateTone(state: string | null | undefined): BadgeTone {
  switch (state) {
    case 'new':
    case 'ok':
      return 'success';
    case 'worn':
      return 'warning';
    case 'broken':
      return 'error';
    default:
      return 'neutral';
  }
}
